<mat-slide-toggle
  [(ngModel)]="customValue"
  [matTooltip]="myTooltip"
  (change)="onClick()">{{btnCaption}}
</mat-slide-toggle>
